<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Công thức</h4>
          </template>
          <template v-slot:body>
            <b-button v-b-modal.modalAddGroupFormular variant="primary" class="mb-4 mt-2" @click="modalFormularName = null; modalFormularId = null">
              <i class="las la-plus"/> Thêm mới
            </b-button>
            <b-button v-b-modal.modalAttachFormulaToGroup variant="primary" class="mb-4 mt-2 ml-2" @click="resetFormModal">
              <i class="las la-bolt"/> Thêm mới vào nhóm
            </b-button>
            <hr>
            <tab-content id="myTabContent">
              <tab-content-item :active="true" aria-labelled-by="home-tab">
                <div class="table-responsive">
                  <b-table
                    id="formular-list-table"
                    ref="formularListTableRef"
                    :items="groupFormularList"
                    :fields="groupFormularFields"
                    :striped="false"
                    :outlined="true"
                    :small="true"
                    :hover="true"
                    :busy="isBusy"
                    :primary-key="'id'"
                    class="table-striped table-bordered table-align-middle"
                    role="grid"
                  >
                    <template v-slot:cell(formular_name)="data">
                      <p v-show="data.item.level === 1" class="text-center"><b>{{ data.item.formular_name }}</b></p>
                      <p v-show="data.item.level === 2">{{ data.item.formular_name }}</p>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="flex list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          v-show="data.item.level === 1"
                          v-b-modal.modalEditGroupFormular
                          @click="modalFormularId = data.item.group_id; modalFormularName = data.item.name"
                        >
                          <i class="las la-pen-alt"></i>
                        </a>
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          @click="confirmDelete(data.item.group_id)"
                          v-show="data.item.level === 1"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>

                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          v-show="data.item.level === 2"
                          @click="confirmDeleteInGroup(data.item.group_id, data.item.formular_id)"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </tab-content-item>
            </tab-content>
          </template>
        </iq-card>

        <b-modal id="modalAddGroupFormular" ok-title="Xác nhận" cancel-title="Đóng" size="md">
          <template #modal-header>
            <h4>Thêm nhóm công thức</h4>
          </template>
          <template #default>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <b-form>
                    <b-form-group label="Tên nhóm">
                      <b-form-input v-model="modalFormularName"/>
                    </b-form-group>
                  </b-form>
                </div>
              </div>
            </div>
          </template>
          <template #modal-footer>
            <b-button variant="primary" @click="actionModalFormularName" :disabled="serverRequesting">Xác nhận</b-button>
            <b-button variant="default" @click="$bvModal.hide('modalAddGroupFormular')">Đóng</b-button>
          </template>
        </b-modal>

        <b-modal id="modalEditGroupFormular" ok-title="Xác nhận" cancel-title="Đóng" size="md">
          <template #modal-header>
            <h4>Đổi tên nhóm công thức</h4>
          </template>
          <template #default>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <b-form>
                    <b-form-group label="Tên nhóm">
                      <b-form-input v-model="modalFormularName"/>
                    </b-form-group>
                  </b-form>
                </div>
              </div>
            </div>
          </template>
          <template #modal-footer>
            <b-button variant="primary" @click="actionModalFormularName" :disabled="serverRequesting">Xác nhận</b-button>
            <b-button variant="default" @click="$bvModal.hide('modalEditGroupFormular')">Đóng</b-button>
          </template>
        </b-modal>

        <b-modal id="modalAttachFormulaToGroup" ok-title="Xác nhận" cancel-title="Đóng" size="lg">
          <template #modal-header>
            <h4>Thêm công thức vào nhóm</h4>
          </template>
          <template #default>
            <div class="container-fluid">
              <div class="row">
                <div class="col-6">
                  <b-form>
                    <b-form-group label="Nhóm công thức">
                      <v-select
                        v-model="attach_group_id"
                        :options="groupFormularOptions" :reduce="opt => opt.id" placeholder="Chọn" @input="onSelectGroupFormularChange($event)"/>
                    </b-form-group>
                    <b-form-group label="Công ty">
                      <v-select
                        v-model="attach_network_id"
                        :options="networksOptions" placeholder="Chọn"
                        :reduce="opt => opt.id"
                        @input="onSelectNetworkChange($event)"
                      />
                    </b-form-group>
                    <b-form-group label="Công thức">
                      <formular-select :disabled="serverRequesting" :formula-options-override="attach_programFormularByNetwork" v-model="attach_formula_id" :inputStyte="{width:'calc(100% - 64px)'}" addBtn />
                    </b-form-group>
                    <b-button style="margin: 0 auto;" variant="primary" @click="actionAttachFormulaToGroup" :disabled="serverRequesting">Xác nhận</b-button>
                  </b-form>
                </div>
                <div class="col-6">
                  <b-table
                    :items="attach_groupFormularList"
                    :fields="attach_groupFormularFields"
                    :striped="false"
                    :outlined="true"
                    :small="true"
                    :hover="true"
                    :primary-key="'id'"
                    class="table-striped table-bordered table-align-middle"
                    role="grid"
                  >
                    <template v-slot:cell(action)="data">
                      <div class="flex list-user-action">
                        <a
                          class="iq-bg-primary"
                          data-toggle="tooltip"
                          data-placement="top"
                          @click="confirmDeleteInGroup(attach_group_id, data.item.formular_id)"
                        >
                          <i class="las la-trash-alt text-red"></i>
                        </a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </template>
          <template #modal-footer>
            <b-button variant="default" @click="$bvModal.hide('modalAttachFormulaToGroup')">Đóng</b-button>
          </template>
        </b-modal>

      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import api from '../../store/api'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import FormularSelect from '../../components/application/formular/FormulaSelect'

export default {
  name: 'GroupFormulaList',
  components: {
    FormularSelect
  },
  async mounted () {
    findash.index()
    this.loadData()
  },
  watch: {
    groupFormular: function (newVal, oldVal) {
      if (newVal) { this.loadData() }
    }
  },
  data () {
    return {
      groupFormularFields: [
        {
          key: 'name',
          label: 'Tên nhóm công thức'
        },
        {
          key: 'network',
          label: 'Công ty',
          class: 'text-center',
          thStyle: { width: '100px' }
        },
        {
          key: 'formular_name',
          label: '',
          class: 'text-left',
          thStyle: { width: '200px' }
        },
        {
          key: 'action',
          label: '',
          class: 'text-right',
          thStyle: { width: '80px' }
        }
      ],
      groupFormularList: [],
      isBusy: false,
      modalFormularId: null,
      modalFormularName: '',
      attach_group_id: null,
      attach_network_id: null,
      attach_formula_id: null,
      attach_groupFormularList: [],
      attach_groupFormularFields: [
        {
          key: 'network',
          label: 'Công ty',
          class: 'text-center',
          thStyle: { width: '100px' }
        },
        {
          key: 'name',
          label: 'Tên nhóm công thức'
        },
        {
          key: 'action',
          label: '',
          class: 'text-right',
          thStyle: { width: '40px' }
        }
      ],
      attach_programFormularByNetwork: []
    }
  },
  computed: {
    ...mapGetters({
      'groupFormular': 'GroupFormular/listState',
      'groupFormularOptions': 'GroupFormular/listOptionsState',
      'networks': 'Network/listState',
      'networksOptions': 'Network/listOptionsState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    ...mapActions({
      'loadGroupAction': 'GroupFormular/loadList'
    }),
    async loadData () {
      let finalRender = []

      _.each(this.groupFormular, (e) => {
        let formularLength = 0
        if (e.formulas !== undefined) {
          formularLength = Object.keys(e.formulas).length
        }

        finalRender.push({
          'name': e.name,
          'network': '',
          'formular_name': formularLength,
          'action': '',
          'level': 1,
          'group_id': e.id,
          'formular_id': null
        })

        if (e.formulas && Object.keys(e.formulas).length > 0) {
          _.each(e.formulas, (d) => {
            let networkName = _.first(_.filter(this.networks, (f) => {
              return f.id === d.network_id
            }))

            finalRender.push({
              'name': '',
              'network': networkName !== undefined ? networkName.name : '',
              'formular_name': d.name,
              'action': '',
              'level': 2,
              'group_id': e.id,
              'formular_id': d.id
            })
          })
        }
      })

      this.groupFormularList = finalRender
    },
    async loadDataFromServer () {
      this.loadGroupAction()
      // render on local
      this.loadData()
    },
    actionModalFormularName () {
      if (this.modalFormularId == null) {
        // add
        api.group_formular.addGroup({
          'name': this.modalFormularName
        }).then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Thêm nhóm thành công'
          })

          this.$bvModal.hide('modalAddGroupFormular')

          this.loadDataFromServer()
        })
      } else {
        // edit
        api.group_formular.editGroup({
          'formula_group_id': this.modalFormularId,
          'name': this.modalFormularName
        }).then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Đổi tên nhóm thành công'
          })

          this.$bvModal.hide('modalEditGroupFormular')

          this.loadDataFromServer()
        })
      }
    },
    confirmDelete (groupFormulaId) {
      this.$swal({
        title: 'Nhóm công thức',
        text: 'Bạn chắc chắn xóa nhóm công thức này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.group_formular.deleteGroup(groupFormulaId).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            this.loadDataFromServer()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    },
    confirmDeleteInGroup (groupFormulaId, formularId) {
      this.$swal({
        title: 'Công thức',
        text: 'Bạn chắc chắn xóa công thức trong nhóm này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.group_formular.deleteFormulaInGroup(groupFormulaId, formularId).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            this.loadDataFromServer()

            if (this.attach_group_id) {
              this.onSelectGroupFormularChange(this.attach_group_id)
            }
          })
        } else if (result.isDenied) {

        }
      })
    },
    onSelectGroupFormularChange (id) {
      api.group_formular.listDetail(id).then((res) => {
        this.attach_groupFormularList = []

        _.each(_.values(res.formulas), (d) => {
          let networkName = _.first(_.filter(this.networks, (f) => {
            return f.id === d.network_id
          }))

          this.attach_groupFormularList.push({
            'name': d.name,
            'network': networkName.name,
            'formular_id': d.id
          })
        })
      })
    },
    onSelectNetworkChange (id) {
      this.attach_formula_id = null

      api.formular.list({
        network_id: id
      }).then((res) => {
        this.attach_programFormularByNetwork = _.map(res, (e) => {
          return { id: e.id, value: e.id, text: e.name, label: e.name }
        })
      })
    },
    actionAttachFormulaToGroup () {
      api.group_formular.attachFomulaToGroup(this.attach_group_id, this.attach_formula_id)
        .then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Thêm thành công'
          })

          if (this.attach_group_id) {
            this.onSelectGroupFormularChange(this.attach_group_id)
          }

          this.loadDataFromServer()
        }).catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Lỗi...',
            text: this.serverError
          })
        })
    },
    resetFormModal () {
      this.attach_group_id = null
      this.attach_network_id = null
      this.attach_formula_id = null
      this.attach_groupFormularList = []
      this.attach_programFormularByNetwork = []
    }
  }
}
</script>
